import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form, Button, Row, Col, Modal } from "react-bootstrap";
import { baseUrl } from "../../../Utility/constants";

const SchoolContactAffiliationDetailsModal = ({
  show,
  handleAffilicationModalClose,
  handleSubmit,
  affiliationFormData,
  setAffiliationFormData,
}) => {
  const [schools, setSchools] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    // Fetch school, state, district, taluka, and city data
    fetchData("SchoolGeneralInfo", setSchools);
    fetchData("StateMaster", setStates);
  }, []);

  const fetchData = async (endpoint, setState) => {
    try {
      const response = await axios.get(`${baseUrl}/api/${endpoint}`);
      setState(response.data);

      if (affiliationFormData.state)
        handleStateChange(affiliationFormData.state);
      if (affiliationFormData.district)
        handleDistrictChange(affiliationFormData.district);
      if (affiliationFormData.taluka)
        handleTalukaChange(affiliationFormData.taluka);
    } catch (error) {
      toast.error(`Failed to load ${endpoint}`);
    }
  };

  const handleStateChange = async (stateId) => {
    setAffiliationFormData({
      ...affiliationFormData,
      state: stateId,
      district: "",
      taluka: "",
      city: "",
    });
    try {
      const response = await axios.get(
        `${baseUrl}/api/DistrictMaster/GetDistrictByState?id=${stateId}`
      );
      setDistricts(response.data);
    } catch (error) {
      toast.error("Failed to load districts");
    }
  };

  const handleDistrictChange = async (districtId) => {
    setAffiliationFormData({
      ...affiliationFormData,
      district: districtId,
      taluka: "",
      city: "",
    });
    try {
      const response = await axios.get(
        `${baseUrl}/api/TalukaMaster/GetTalukaByDistrict?id=${districtId}`
      );
      setTalukas(response.data);
    } catch (error) {
      toast.error("Failed to load talukas");
    }
  };

  const handleTalukaChange = async (talukaId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/CityVillageMaster/GetCityVillageBtTaluka?id=${talukaId}`
      );
      setCities(response.data);

      // Check if the current city ID exists in the new city list, and set it if needed
      //const cityExists = response.data.filter( x => x.id === affiliationFormData.city);
      if (
        response.data.some(
          (city) => city.id === parseInt(affiliationFormData.city)
        )
      ) {
        setAffiliationFormData({
          ...affiliationFormData,
          taluka: talukaId,
          city: affiliationFormData.city, // Reassign city if valid
        });
      } else {
        setAffiliationFormData({
          ...affiliationFormData,
          taluka: talukaId,
          city: "", // Reset if the city doesn't match the taluka
        });
      }
    } catch (error) {
      toast.error("Failed to load cities");
    }
  };

  const handleCityChange = (cityId) => {
    setAffiliationFormData({
      ...affiliationFormData,
      city: cityId,
    });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleAffilicationModalClose}
        dialogClassName="custom-modal-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update School Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>School</Form.Label>
                  <Form.Control
                    as="select"
                    value={affiliationFormData.schoolId}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        schoolId: e.target.value,
                      })
                    }
                    required
                    disabled
                  >
                    <option value="">Select School</option>
                    {schools.map((school) => (
                      <option key={school.schoolId} value={school.schoolId}>
                        {school.schoolOrCollegeName}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={affiliationFormData.email}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        email: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>School or College Contact No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={affiliationFormData.schoolOrCollegeContactNo}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        schoolOrCollegeContactNo: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>ERP Web link</Form.Label>
                  <Form.Control
                    type="url"
                    value={affiliationFormData.websiteName}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        websiteName: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>
              </Col>
               <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Website link</Form.Label>
                  <Form.Control
                    type="url"
                    value={affiliationFormData.schoolWebsiteName}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        schoolWebsiteName: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>
              </Col>
            
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Principal Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={affiliationFormData.principalName}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        principalName: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Principal Contact No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={affiliationFormData.principalContactNo}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        principalContactNo: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={affiliationFormData.address}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        address: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="text"
                    value={affiliationFormData.pincode}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        pincode: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>
              </Col>
               <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    as="select"
                    value={affiliationFormData.state}
                    onChange={(e) => handleStateChange(e.target.value)}
                    required
                  >
                    <option value="">Select State</option>
                    {states.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            {/* Existing State, District, Taluka, City dropdowns */}
            <Row>
             
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>District</Form.Label>
                  <Form.Control
                    as="select"
                    value={affiliationFormData.district}
                    onChange={(e) => handleDistrictChange(e.target.value)}
                    required
                    disabled={!affiliationFormData.state}
                  >
                    <option value="">Select District</option>
                    {districts.map((district) => (
                      <option key={district.id} value={district.id}>
                        {district.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Taluka</Form.Label>
                  <Form.Control
                    as="select"
                    value={affiliationFormData.taluka}
                    onChange={(e) => handleTalukaChange(e.target.value)}
                    required
                    disabled={!affiliationFormData.district}
                  >
                    <option value="">Select Taluka</option>
                    {talukas.map((taluka) => (
                      <option key={taluka.id} value={taluka.id}>
                        {taluka.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    as="select"
                    value={affiliationFormData.city}
                    onChange={(e) => handleCityChange(e.target.value)}                    
                    required
                    disabled={!affiliationFormData.taluka}
                  >
                    <option value="">Select City</option>
                    {cities.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            {/* Additional fields for Bifocal, IT, Minority */}
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Bifocal"
                    checked={affiliationFormData.bifocal}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        bifocal: e.target.checked,
                      })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="IT"
                    checked={affiliationFormData.it}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        it: e.target.checked,
                      })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Minority"
                    checked={affiliationFormData.minority}
                    onChange={(e) =>
                      setAffiliationFormData({
                        ...affiliationFormData,
                        minority: e.target.checked,
                      })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            {affiliationFormData.minority && (
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Minority Type</Form.Label>
                    <Form.Control
                      as="select"
                      value={affiliationFormData.minorityType}
                      onChange={(e) =>
                        setAffiliationFormData({
                          ...affiliationFormData,
                          minorityType: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="NA">NA</option>
                      <option value="Religious">Religious</option>
                      <option value="Linguistic">Linguistic</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            )}
            
            <Modal.Footer>
              <Button variant="secondary" onClick={handleAffilicationModalClose}>
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Save Changes
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
        
      </Modal>
    </>
  );
};

export default SchoolContactAffiliationDetailsModal;
